<script lang="ts">
  import clsx from 'clsx';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import type { HeadingSmallProps } from './types';
  let { class: className, size = 'small', ...props }: HeadingSmallProps = $props();
</script>

<BaseHeading class={clsx(className)} {size} level={3} {...props} />
